import { roles } from "constants/index";

export const rolesGetAllShop = [roles.admin, roles.qs, roles.regionManager, roles.viceRegionManager]

export const rolesManualSync = [roles.admin]

export const rolesNotEdit = [roles.qs]